export enum ButtonType {
  PRIMARY,
  SECONDARY,
}